import { useState, useRef, Fragment } from "react";
import Config from "../../Config";
import AppContext from "../../AppContext";
import InputDate from "../../helpers/InputDate";
import FormatTime from "../../helpers/FormatTime";
import MenuTable from "../../helpers/MenuTable";
import HtmlToPDF from "../../exporter/HtmlToPDF";
import InputTime from "../../helpers/InputTime";
import InputKidsMulti from "../../helpers/InputKidsMultiE";
import InputColor from "../../helpers/InputColor";
import InputCombo from "../../helpers/InputCombo";

export default function Hours(props)
{

    const tabRef = useRef(0);
    const tab2Ref = useRef(0);

    const tabRefB = useRef(0);
    const tab2RefB = useRef(0);

    const [errTab, setErrTab] = useState([]);  //z info od serwera.. 


        const [filterParam, setFilterParam] = useState({  

        men_dziennik_id: props.id,
        dzien_od: props.mainView.readFilter('dzien_od',''), 
        dzien_do: props.mainView.readFilter('dzien_do',''),  
      
        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },

        limit: 50,
        page: 1,
        pages: 1,
        show: true,
    });
    const [tab, setTab] = useState(null);

    const [kids, setKids] = useState(null);





 const [row, setRowX] = useState({
          men_dziennik_id: props.id,
          p_dziecko_id: '-1',
          dzien: '',
          wejscie: '',
          wyjscie: '',
       });



          const [view, setView] = useState ( {
            v:'list',
            id: -1
        } );
       
        const changeView = (e ) => {
            var v = e.target.getAttribute('v');
            var id = e.target.getAttribute('id');

            setView({...view, ["v"]:v, ["id"]:id }); 
        }




    const valChangeListener = (filedName, val, correct, msg) => {

            //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

            setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );

             if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 1000;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }
           

            props.mainView.writeFilter(filedName, val);
        }



        const valChangeListenerF = (filedName, val, correct, msg) => {         
             console.log("valChangeListenerF: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg); 
                        
         
             setRowX( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );              
        } 


    const goNextNew = () => {
        console.log("goNext");    
        setTab(null);    
    }

            
      const filterClear = () => {
 
            props.mainView.writeFilter('dzien_od', '');
            props.mainView.writeFilter('dzien_do', '');          
            setFilterParam({
 
                men_dziennik_id: props.id,
                dzien_od: '',                 
                dzien_do: '',                                       

                sortBy: {
                    sort:  "", //asc desc,
                    column: "",
                },


                limit: 50,
                page: 1,
                show: true, 
            });
            setTab(null);
        }


 const filterApprove = () => {   
     setTab(null)     
 }





const getTab = () => {
       
 
    props.mainView.setProgress(-2);
   

    fetch( Config.url + '/rest_v1_men,hours', {
        method: 'POST', 
        body: JSON.stringify(filterParam), 
        headers: {
            'Content-Type': 'application/json',                    
            'X-Api-Key': props.userData.apiKey,
            '_p_przedszkole_id_': props.userData.p_przedszkole_id,
            '_p_dziecko_id_': props.userData.p_dziecko_id,
            '_sec_key_': Config.genXKey() ,
        }
     })
     .then(res => res.json() )
     .then(res => { 

                props.mainView.setProgress(-1);        
                if(res._sys_ == undefined)
                {
                    props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                }else
                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                {
                    props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                }else    
                {
                    setTab(res.result);             

                    if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                }
     } )
     .catch(err => {          
                props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                props.mainView.setProgress(-1);
     });
               

     return false;
}


const getKids = () => {
       
 
    props.mainView.setProgress(-2);
   

    fetch( Config.url + '/rest_v1_men,dz_kids', {
        method: 'POST', 
        body: JSON.stringify({
            men_dziennik_id: props.id
        }), 
        headers: {
            'Content-Type': 'application/json',                    
            'X-Api-Key': props.userData.apiKey,
            '_p_przedszkole_id_': props.userData.p_przedszkole_id,
            '_p_dziecko_id_': props.userData.p_dziecko_id,
            '_sec_key_': Config.genXKey() ,
        }
     })
     .then(res => res.json() )
     .then(res => { 

                props.mainView.setProgress(-1);        
                if(res._sys_ == undefined)
                {
                    props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                }else
                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                {
                    props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                }else    
                {
                    setKids(res.result);                                
                }
     } )
     .catch(err => {          
                props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                props.mainView.setProgress(-1);
     });
               

     return false;
}


const saveData = () => {


    if(row.p_dziecko_id == '_x_' || row.p_dziecko_id < 1)
    {
         props.mainView.showDialog( "Error", "Wybierz dziecko" , "ok" , null);   
         return;
    }

    if(row.dzien == undefined || row.dzien.length < 2)
    {
        props.mainView.showDialog( "Error", "Wskaż dzień" , "ok" , null);   
         return;
    }


    if( row.wejscie.length < 2 && row.wyjscie.length < 2)
    {
        props.mainView.showDialog( "Error", "Podaj godzinie wejścia lub wyjścia" , "ok" , null);   
         return;
    }


    props.mainView.setProgress(-2);
   

    fetch( Config.url + '/rest_v1_men,hours_add', {
        method: 'POST', 
        body: JSON.stringify(row), 
        headers: {
            'Content-Type': 'application/json',                    
            'X-Api-Key': props.userData.apiKey,
            '_p_przedszkole_id_': props.userData.p_przedszkole_id,
            '_p_dziecko_id_': props.userData.p_dziecko_id,
            '_sec_key_': Config.genXKey() ,
        }
     })
     .then(res => res.json() )
     .then(res => { 

                props.mainView.setProgress(-1);        
                if(res._sys_ == undefined)
                {
                    props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                }else
                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                {
                    props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                }else    
                {
                    setTab(null);                              
                }
     } )
     .catch(err => {          
                props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                props.mainView.setProgress(-1);
     });


}



const updateData = () => {


    if(row.p_dziecko_id == '_x_' || row.p_dziecko_id < 1)
    {
         props.mainView.showDialog( "Error", "Wybierz dziecko" , "ok" , null);   
         return;
    }

    if(row.dzien == undefined || row.dzien.length < 2)
    {
        props.mainView.showDialog( "Error", "Wskaż dzień" , "ok" , null);   
         return;
    }


    if( row.wejscie.length < 2 && row.wyjscie.length < 2)
    {
        props.mainView.showDialog( "Error", "Podaj godzinie wejścia lub wyjścia" , "ok" , null);   
         return;
    }


    props.mainView.setProgress(-2);
   

    fetch( Config.url + '/rest_v1_men,hours_update', {
        method: 'POST', 
        body: JSON.stringify(row), 
        headers: {
            'Content-Type': 'application/json',                    
            'X-Api-Key': props.userData.apiKey,
            '_p_przedszkole_id_': props.userData.p_przedszkole_id,
            '_p_dziecko_id_': props.userData.p_dziecko_id,
            '_sec_key_': Config.genXKey() ,
        }
     })
     .then(res => res.json() )
     .then(res => { 

                props.mainView.setProgress(-1);        
                if(res._sys_ == undefined)
                {
                    props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                }else
                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                {
                    props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                }else    
                {
                    setView({v:'list',id:-1});
                    setTab(null);                              
                }
     } )
     .catch(err => {          
                props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                props.mainView.setProgress(-1);
     });


}


const goEdit = (e) => {

            var inx = e.target.getAttribute("inx");

            var tt = {
                    men_dziennik_id: props.id,
                    p_dziecko_id: tab[inx].dziecko.id,
                    id: tab[inx].id,
                    dzien: tab[inx].dzien,
                    wejscie: tab[inx].wejscie,
                    wyjscie: tab[inx].wyjscie,
            };

            setRowX(tt);

            setView({v:"edit",id:-1});
}



   const deleteRecord = (e) => {

                var id = e.target.getAttribute("id");
                props.mainView.showDialog( "Pytanie", "Na pewno chcesz usunąć wpis?" , "yesno" ,  (param) => {
                        
                            if(param == "yes")
                            {
                            deleteRecordYes(id)
                            }
                    } );
}

  const deleteRecordYes = (id)  => {

            
            var req = {
                id: id,
                men_dziennik_id: props.id,
            };

            props.mainView.setProgress(-2);
        

            fetch( Config.url + '/rest_v1_men,hours_remove', {
                method: 'POST', 
                body: JSON.stringify(req), 
                headers: {
                    'Content-Type': 'application/json',                    
                    'X-Api-Key': props.userData.apiKey,
                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                    '_sec_key_': Config.genXKey() ,
                }
            })
            .then(res => res.json() )
            .then(res => { 

                        props.mainView.setProgress(-1);        
                        if(res._sys_ == undefined)
                        {
                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                        }else
                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                        {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                        }else    
                        {     
                            setTab(null);
                            props.mainView.showDialog( "Sukces", "Wpis został usunięty" , "ok" , (param)=>{
                                     setTab(null);                       
                            } );  
                        }
            } )
            .catch(err => {          
                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                        props.mainView.setProgress(-1);
            });
                    

            return false;

        }






   if(tab == null)
   {
      setTab([]); 
      getTab();   
      getKids();   
    
      return <div>...</div>
   }




      var viewDialog = null;

    if(view.v == "new")
    {
                viewDialog =   <div className="dlg_window dlg_type_x shadowx">
            
                                    <div className="dlg_title">
                                        Nowa pozycja
                                    </div>

                                    <div className="dlg_content_x scroll500">

                                              <div className="form_tab">
                                                

                                                            <div className="form_control">
                                                                <div className="fieldName">Dziecko*</div>
                                                                <InputCombo items={kids}   userData={props.userData} mainView={props.mainView} value={row.p_dziecko_id} err={errTab}  valChange={valChangeListenerF} goNext={goNextNew} name="p_dziecko_id" placeholder={":"} className='   ' req='1' firstUp="0" />
                                                            </div>

                                                            <div className="form_control">
                                                                <div className="fieldName">Dzień*</div>
                                                                <InputDate   userData={props.userData} value={row.dzien} err={errTab}  valChange={valChangeListenerF} goNext={goNextNew} name="dzien" placeholder={":"} className='   ' req='1' firstUp="0" />
                                                            </div>


                                                            <div className="form_control">
                                                                <div className="fieldName">Wejście*</div>
                                                                <InputTime   userData={props.userData} value={row.wejscie} err={errTab}  valChange={valChangeListenerF} goNext={goNextNew} name="wejscie" placeholder={":"} className='   ' req='0' firstUp="0" />
                                                            </div>

                                                            <div className="form_control">
                                                                <div className="fieldName">Wyjście*</div>
                                                                <InputTime   userData={props.userData} value={row.wyjscie} err={errTab}  valChange={valChangeListenerF} goNext={goNextNew} name="wyjscie" placeholder={":"} className='   ' req='0' firstUp="0" />
                                                            </div>

                                                            <div className="form_split"></div>
 

                                              </div>


                                    <div className="form_split"></div>

                                            <div className="form_control">                                            
                                                <div className="btn" onClick={saveData}>dodaj</div>
                                                &nbsp; &nbsp;
                                                <div className="btn" onClick={changeView}>anuluj</div>
                                            </div>

                                    </div>

                            </div>
    }
       

    if(view.v == "edit")
    {
                viewDialog =   <div className="dlg_window dlg_type_x shadowx">
            
                                    <div className="dlg_title">
                                        Edycja pozycji
                                    </div>

                                    <div className="dlg_content_x scroll500">

                                              <div className="form_tab">
                                                

                                                            <div className="form_control">
                                                                <div className="fieldName">Dziecko*</div>
                                                                <InputCombo items={kids}   userData={props.userData} mainView={props.mainView} value={row.p_dziecko_id} err={errTab}  valChange={valChangeListenerF} goNext={goNextNew} name="p_dziecko_id" placeholder={":"} className='   ' req='1' firstUp="0" />
                                                            </div>
 


                                                            <div className="form_control">
                                                                <div className="fieldName">Wejście*</div>
                                                                <InputTime   userData={props.userData} value={row.wejscie} err={errTab}  valChange={valChangeListenerF} goNext={goNextNew} name="wejscie" placeholder={":"} className='   ' req='0' firstUp="0" />
                                                            </div>

                                                            <div className="form_control">
                                                                <div className="fieldName">Wyjście*</div>
                                                                <InputTime   userData={props.userData} value={row.wyjscie} err={errTab}  valChange={valChangeListenerF} goNext={goNextNew} name="wyjscie" placeholder={":"} className='   ' req='0' firstUp="0" />
                                                            </div>

                                                            <div className="form_split"></div>
 

                                              </div>


                                    <div className="form_split"></div>

                                            <div className="form_control">                                            
                                                <div className="btn" onClick={updateData}>dodaj</div>
                                                &nbsp; &nbsp;
                                                <div className="btn" onClick={changeView}>anuluj</div>
                                            </div>

                                    </div>

                            </div>
    }



   return <div>
    

            <div className="table_filter">                                                                                               
                        <div className="filter_controll">   
                                    <label>Od dnia: </label>                             
                                         <InputDate   userData={props.userData}  mainView={props.mainView}   value={filterParam.dzien_od}   valChange={valChangeListener} goNext={goNextNew} name="dzien_od" placeholder={": "}  noempty="0"   />
                        </div>

                        <div className="filter_controll">   
                                           <label>Do dnia: </label>                             
                                           <InputDate   userData={props.userData}  mainView={props.mainView}   value={filterParam.dzien_do}   valChange={valChangeListener} goNext={goNextNew} name="dzien_do" placeholder={": "}  noempty="0"   />
                        </div>

                        <div className="filter_btn">                           
                                            <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                        </div>
            </div>


              <div className="table_widget">   
                        {
                            props.status == "aktywny" &&
                            <div className="btn" onClick={changeView} v="new" id="-1"  > dodaj pozycje</div>
                        }
                       

                        &nbsp;&nbsp;                              

                        <HtmlToPDF tabRef={tabRef} userData={props.userData} mainView={props.mainView}  orientation="landscape" title={props.title  } />    
                    </div>



               <div className="scorll_x">
                                                            

                                                                                <table className="table" >

                                                                                            <thead>
                                                                                                    <tr className="header">                                                    
                                                                                                        <td className="td_left">LP</td>                                                                                                                                           
                                                                                                        <td className="">Dziecko</td>                                                                                                                                           
                                                                                                        <td className="">Dzień</td>                                                                                                                                           
                                                                                                        <td>Godzina wejścia</td>                                              
                                                                                                        <td className="td_right" >Godzina wyjścia</td>                                                                                                                                                                                                                                                                                                                                               
                                                                                                        <td className="td_option"> </td>                                              
                                                                                                    </tr>
                                                                                            </thead>

                                                                                            <tbody>

                                                                                                {
                                                                                                    tab.map( (item, ixKey) => {

                                                                                                        var rowStyle = " row ";
                                                                                                        if(ixKey % 2 == 0 )rowStyle = " row2 ";


                                                                                                        return <tr className={rowStyle} key={ixKey}>
                                                                                                                <td className="gocenter">{ixKey+1}</td>                                                                                                                                           
                                                                                                                <td className="goleft">{item.dziecko.nazwisko} {item.dziecko.imie}</td>                                                                                                                                           
                                                                                                                <td className="gocenter">{item.dzien}</td>                                                                                                                                           
                                                                                                                <td className="gocenter">{item.wejscie} </td>                                              
                                                                                                                <td className="gocenter">{item.wyjscie} </td>                                                                                                                                                                                         
                                                                                                                                                                                                                                                                                                                                                  
                                                                                                                <MenuTable>
                                                                                                                            <ul> 
                                                                                                                                {
                                                                                                                                    props.status == "aktywny" &&
                                                                                                                                    <Fragment>
                                                                                                                                         <li onClick={deleteRecord}  id={item.id}  >usuń</li>  
                                                                                                                                         <li onClick={goEdit}  inx={ixKey}  >edytuj</li>  
                                                                                                                                    </Fragment>
                                                                                                                                }                                                                      
                                                                                                                                                                                                    
                                                                                                                            </ul>                                                               
                                                                                                                </MenuTable>  
                                                                                                        </tr>

                                                                                                    } )
                                                                                                }

                                                                                            </tbody>

                                                                                </table>
               </div>


            {viewDialog}

   </div>


}